<template>
    <div class="login-container">
        <!-- 左上角Logo -->
        <div class="top-left-logo">
            <div class="logo-img">
                <img src="../../static/image/logo.png" alt="英语学习平台logo">
            </div>
            <div class="logo-text">
                <div>习传阅读</div>
                <div class="logo-text-en">XiChuan Reading</div>
            </div>
        </div>

        <!-- 装饰元素 -->
        <div class="decor-elements">
            <div class="decor-item"><i class="fa fa-book-open"></i></div>
            <div class="decor-item"><i class="fa fa-globe"></i></div>
            <div class="decor-item"><i class="fa fa-graduation-cap"></i></div>
        </div>

        <!-- 登录卡片 -->
        <div class="login-wrapper">
            <div class="login-left">
                <div class="brand-title">习传阅读</div>
                <div class="brand-slogan">让英语学习更简单，让未来更多可能</div>
                <div class="feature-list">
                    <div class="feature-item">
                        <!-- 纯正发音图标 -->
                        <i class="fa fa-volume-up" aria-hidden="true"></i>
                        <div class="feature-text">纯正发音</div>
                    </div>
                    <div class="feature-item">
                        <!-- 海量资源图标 -->
                        <i class="fa fa-book" aria-hidden="true"></i>
                        <div class="feature-text">海量资源</div>
                    </div>
                    <div class="feature-item">
                        <!-- 智能规划图标 -->
                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                        <div class="feature-text">智能规划</div>
                    </div>
                    <div class="feature-item">
                        <!-- 互动学习图标 -->
                        <i class="fa fa-comments" aria-hidden="true"></i>
                        <div class="feature-text">互动学习</div>
                    </div>
                </div>
            </div>

            <div class="login-right">
                <div class="login-header">
                    <h3 class="welcome">欢迎<span>登录</span></h3>
                    <p class="sub-welcome">开启你的专属英语学习之旅</p>
                </div>
                
                <!-- 登录表单 -->
                <form>
                    <div class="input-item">
                        <label class="input-label">账号</label>
                        <div class="input-wrap">
                            <!-- 账号图标 -->
                            <i class="fa fa-user" aria-hidden="true"></i>
                            <el-input 
                            type="text" 
                            placeholder="请输入你的账号" 
                            v-model="LoginForm.account"
                            required
                            >
                            </el-input>
                        </div>
                    </div>
                    
                    <div class="input-item">
                        <label class="input-label">密码</label>
                        <div class="input-wrap">
                            <!-- 密码图标 -->
                            <i class="fa fa-lock" aria-hidden="true"></i>
                            <el-input 
                            type="password" 
                            placeholder="请输入你的密码" 
                            v-model="LoginForm.password"
                            required
                            >
                            </el-input>
                        </div>
                    </div>
                    
                    <div class="options">
                        <label class="remember">
                            <input 
                            type="checkbox" 
                            v-model="LoginForm.remember"
                            > 记住登录状态
                        </label>
                        <!-- <a href="#" class="forgot" @click.prevent>忘记密码？</a> -->
                    </div>
                    
                    <el-button :loading="loading" @click="submitFormLogin" type="submit" class="login-btn">立即登录</el-button>
                </form>
                
                <!-- <div class="register">
                    还没有账号？<a href="#" @click.prevent>注册新账号</a>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Http from "../apis/user";
export default {
    
    name: 'LoginPage',
    data() {
        return {
            LoginForm: {
                account: '',
                password: '',
                remember: false
            },
            redirect:'',
            loading: false,
        }
    },
    mounted() {
        this.redirect = this.$route.query.redirect
        this.loadRememberInfo()
    },
    methods: {
        loadRememberInfo() {
            const rememberInfo = localStorage.getItem('rememberInfo')
            if (rememberInfo) {
                const info = JSON.parse(rememberInfo)
                this.LoginForm.account = info.account
                this.LoginForm.password = info.password
                this.LoginForm.remember = true
            }
        },
        saveRememberInfo() {
            if (this.LoginForm.remember) {
                localStorage.setItem('rememberInfo', JSON.stringify({
                    account: this.LoginForm.account,
                    password: this.LoginForm.password
                }))
            } else {
                localStorage.removeItem('rememberInfo')
            }
        },
        submitFormLogin() {
            this.loading = true
            var login_data = this.LoginForm
            if (!login_data.account) {
                this.$message.error('请填写账号');
                return false;
            }
            if (!login_data.password) {
                this.$message.error('请填写密码');
                return false;
            }
            Http.Login(this.LoginForm).then((res) => {
                this.loading = false
                this.$message({
                showClose: true,
                message: res.msg,
                type: res.code ? 'success' : 'error'
                });
                if (res.code) {
                window.sessionStorage.setItem("token", res.data.userinfo.token);
                window.sessionStorage.setItem("userinfo", JSON.stringify(res.data.userinfo));
                this.saveRememberInfo()

                if(this.redirect){

                    window.location.href = decodeURIComponent(this.redirect);
                    return false;
                }

                if(res.data.userinfo.type == 0){
                    this.$router.push({ name: 'StudentPlan' });
                }else{
                    this.$router.push({ name: 'Plan' });
                }

                }

            });
        },
    }

}

</script>

<style>
/* 全局基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", "Microsoft YaHei", "Segoe UI", Roboto, sans-serif;
}

/* 直接引入Font Awesome CDN（彻底解决依赖问题） */
@import url('https://cdn.bootcdn.net/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');

:root {
  --primary-blue: #165DFF;
  --light-blue: #E8F3FF;
  --medium-blue: #4080FF;
  --dark-blue: #0E42D2;
  --border-blue: #C9E0FF;
  --text-dark: #1D2129;
  --text-gray: #4E5969;
  --text-light: #86909C;
  --bg-white: #FFFFFF;
  --bg-gray: #F7F8FA;
  --overlay: rgba(255, 255, 255, 0.85);
  --shadow-xs: 0 1px 2px rgba(22, 93, 255, 0.05);
  --shadow-sm: 0 2px 8px rgba(22, 93, 255, 0.08);
  --shadow-md: 0 4px 16px rgba(22, 93, 255, 0.12);
  --shadow-lg: 0 8px 24px rgba(22, 93, 255, 0.15);
}

/* 强制图标显示 - 核心修复 */
.fa {
  display: inline-block !important;
  font: normal normal normal 14px/1 FontAwesome !important;
  font-size: inherit !important;
  text-rendering: auto !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  color: inherit !important;
  width: 20px !important;
  height: 20px !important;
  text-align: center !important;
}

.login-container {
  min-height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  background: linear-gradient(var(--overlay), var(--overlay)),
    url('../../static/image/login_bg.png') 
    no-repeat center center / cover !important;
  background-attachment: fixed !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 20px !important;
  position: relative !important;
}

/* 左上角Logo */
.top-left-logo {
  position: absolute !important;
  top: 30px !important;
  left: 40px !important;
  z-index: 20 !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}

.logo-img {
  width: 80px !important;
  height: 80px !important;
  border-radius: 50% !important;
  background: var(--bg-white) !important;
  box-shadow: var(--shadow-sm) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.logo-img img {
  width: 68px !important;
  height: 68px !important;
  object-fit: contain !important;
  border-radius: 50% !important;
}

.logo-text {
  font-size: 22px !important;
  font-weight: 700 !important;
  
  white-space: nowrap !important;
}

.logo-text-en {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: var(--text-gray) !important;
  margin-top: 4px !important;
  font-family: "Georgia", "Times New Roman", serif !important;
  font-style: italic !important;
}

/* 装饰元素 */
.decor-elements {
  position: absolute !important;
  width: 100% !important;
  height: 100% !important;
  pointer-events: none !important;
  z-index: 1 !important;
  opacity: 0.1 !important;
}

.decor-item {
  position: absolute !important;
  color: var(--primary-blue) !important;
  opacity: 0.05 !important;
  font-size: 120px !important;
  animation: float 30s ease-in-out infinite !important;
}

.decor-item:nth-child(1) { top: 10% !important; left: 8% !important; animation-delay: 0s !important; }
.decor-item:nth-child(2) { bottom: 15% !important; right: 10% !important; animation-delay: 10s !important; }
.decor-item:nth-child(3) { top: 60% !important; left: 20% !important; animation-delay: 20s !important; }

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg) !important; }
  50% { transform: translateY(-40px) rotate(3deg) !important; }
}

/* 登录卡片 */
.login-wrapper {
  width: 100% !important;
  max-width: 800px !important;
  background: rgba(255, 255, 255, 0.9) !important;
  border-radius: 24px !important;
  box-shadow: var(--shadow-md) !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: row !important;
  position: relative !important;
  z-index: 10 !important;
  transition: all 0.4s ease !important;
}

.login-wrapper:hover {
  box-shadow: var(--shadow-lg) !important;
  transform: translateY(-2px) !important;
}

/* 左侧蓝色区域 */
.login-left {
  width: 45% !important;
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--dark-blue) 100%) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  color: var(--bg-white) !important;
  padding: 60px 30px !important;
  text-align: center !important;
  position: relative !important;
}

.login-left::before {
  content: "" !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background: radial-gradient(circle at 60% 40%, rgba(255, 255, 255, 0.15) 0%, transparent 60%) !important;
  z-index: 1 !important;
  pointer-events: none !important;
}

.brand-title {
  font-size: 28px !important;
  font-weight: 700 !important;
  margin-bottom: 10px !important;
  position: relative !important;
  z-index: 2 !important;
  letter-spacing: 0.5px !important;
}

.brand-slogan {
  font-size: 14px !important;
  opacity: 0.9 !important;
  line-height: 1.6 !important;
  position: relative !important;
  z-index: 2 !important;
  max-width: 230px !important;
}

.feature-list {
  width: 100% !important;
  margin-top: 40px !important;
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 12px !important;
  position: relative !important;
  z-index: 2 !important;
}

.feature-item {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 6px !important;
  padding: 15px 8px !important;
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
  font-size: 12px !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  transition: all 0.3s ease !important;
}

.feature-item:hover {
  background: rgba(255, 255, 255, 0.18) !important;
  transform: translateY(-3px) !important;
}

.feature-item i {
  font-size: 20px !important;
  color: var(--bg-white) !important;
  margin-bottom: 4px !important;
}

/* 右侧登录表单 */
.login-right {
  width: 55% !important;
  padding: 60px 50px !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  position: relative !important;
  background: transparent !important;
}

.login-header {
  margin-bottom: 40px !important;
}

.login-header .welcome {
  font-size: 32px !important;
  color: var(--text-dark) !important;
  margin-bottom: 8px !important;
  font-weight: 700 !important;
  letter-spacing: -0.5px !important;
}

.login-header .welcome span {
  color: var(--primary-blue) !important;
}

.login-header .sub-welcome {
  font-size: 15px !important;
  color: var(--text-gray) !important;
  line-height: 1.5 !important;
}

/* 输入框 */
.input-item {
  margin-bottom: 24px !important;
  position: relative !important;
}

.input-item .input-label {
  display: block !important;
  font-size: 14px !important;
  color: var(--text-gray) !important;
  margin-bottom: 15px !important;
  font-weight: 500 !important;
  text-align: left;
}

.input-wrap {
  position: relative !important;
  width: 100% !important;
  height: 52px !important;
  background: var(--bg-gray) !important;
  border-radius: 12px !important;
  border: 1px solid transparent !important;
  transition: all 0.3s ease !important;
}

.input-wrap:focus-within {
  background: var(--bg-white) !important;
  border-color: var(--border-blue) !important;
  box-shadow: var(--shadow-xs) !important;
}

.input-item i {
  position: absolute !important;
  left: 18px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: var(--text-light) !important;
  font-size: 18px !important;
  transition: all 0.3s ease !important;
  z-index: 2 !important;
}

.input-wrap:focus-within i {
  color: var(--primary-blue) !important;
}

.input-item input {
  width: 100% !important;
  height: 50px !important;
  padding: 0 20px 0 52px !important;
  border: none !important;
  outline: none !important;
  font-size: 15px !important;
  background: transparent !important;
  color: var(--text-dark) !important;
  border-radius: 12px !important;
}

.input-item input::placeholder {
  color: var(--text-light) !important;
}

/* 选项区域 */
.options {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  margin-bottom: 32px !important;
  font-size: 14px !important;
}

.remember {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  cursor: pointer !important;
  color: var(--text-gray) !important;
}

.remember input {
  accent-color: var(--primary-blue) !important;
  width: 16px !important;
  height: 16px !important;
  cursor: pointer !important;
}

.forgot {
  color: var(--primary-blue) !important;
  text-decoration: none !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
}

.forgot:hover {
  color: var(--medium-blue) !important;
  text-decoration: underline !important;
}

/* 登录按钮 */
.login-btn {
  width: 100% !important;
  height: 56px !important;
  background: linear-gradient(90deg, var(--primary-blue) 0%, var(--dark-blue) 100%) !important;
  color: var(--bg-white) !important;
  border: none !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  box-shadow: var(--shadow-sm) !important;
  margin-bottom: 30px !important;
  letter-spacing: 0.3px !important;
  position: relative !important;
  overflow: hidden !important;
}

.login-btn::before {
  content: "" !important;
  position: absolute !important;
  top: 0 !important;
  left: -100% !important;
  width: 100% !important;
  height: 100% !important;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.12), transparent) !important;
  transition: all 0.8s ease !important;
}

.login-btn:hover {
  box-shadow: var(--shadow-md) !important;
  transform: translateY(-2px) !important;
}

.login-btn:hover::before {
  left: 100% !important;
}

.login-btn:active {
  transform: translateY(0) !important;
  box-shadow: var(--shadow-xs) !important;
  background: linear-gradient(90deg, var(--dark-blue) 0%, var(--primary-blue) 100%) !important;
}

/* 注册链接 */
.register {
  text-align: center !important;
  font-size: 14px !important;
  color: var(--text-gray) !important;
  position: relative !important;
  padding-top: 20px !important;
}

.register::before {
  content: "" !important;
  position: absolute !important;
  top: 0 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 70px !important;
  height: 1px !important;
  background: var(--border-blue) !important;
  opacity: 0.5 !important;
}

.register a {
  color: var(--primary-blue) !important;
  font-weight: 600 !important;
  text-decoration: none !important;
  margin-left: 4px !important;
  transition: all 0.2s ease !important;
  position: relative !important;
}

.register a::after {
  content: "" !important;
  position: absolute !important;
  bottom: -2px !important;
  left: 0 !important;
  width: 0 !important;
  height: 2px !important;
  background: var(--primary-blue) !important;
  transition: all 0.3s ease !important;
}

.register a:hover {
  color: var(--medium-blue) !important;
}

.register a:hover::after {
  width: 100% !important;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .top-left-logo {
    top: 20px !important;
    left: 20px !important;
  }
  
  .logo-img {
    width: 50px !important;
    height: 50px !important;
  }
  
  .logo-img img {
    width: 40px !important;
    height: 40px !important;
  }
  
  .logo-text {
    font-size: 16px !important;
  }
  
  .login-wrapper {
    flex-direction: column !important;
    max-width: 420px !important;
    border-radius: 20px !important;
  }
  
  .login-left, .login-right {
    width: 100% !important;
  }
  
  .login-left {
    padding: 45px 25px !important;
  }
  
  .login-right {
    padding: 45px 30px !important;
  }
  
  .login-header .welcome {
    font-size: 26px !important;
  }
  
  .feature-list {
    gap: 10px !important;
  }
  
  .feature-item {
    padding: 12px 6px !important;
  }
}

@media (max-width: 400px) {
  .logo-text {
    display: none !important;
  }
}
</style>